module.exports = __webpack_public_path__ + "static/media/PupsandPaws.55d0ca49.ico";